import { Typography } from '@/components/ui/Text';
import clsx from 'clsx';
import { TBlogModuleBlockQuote } from '../../blog/blog.types';

import './BlogArticleModuleBlockQuote.scss';

type Props = {
  module: TBlogModuleBlockQuote;
  mobile?: boolean;
};

const PRE_AUTHOR_CONTENT = '—';

export const BlogArticleModuleBlockQuote: React.FC<Props> = ({
  module: { author, innerText, backgroundColor },
  mobile = false,
}) => {
  return (
    <div
      className={clsx('BlogArticleModuleBlockQuote', {
        'BlogArticleModuleBlockQuote--mobile': mobile,
        'BlogArticleModuleBlockQuote--desktop': !mobile,
      })}
      style={{ backgroundColor }}
    >
      <div className='BlogArticleModuleBlockQuote__content'>
        <Typography variant='body'>{innerText}</Typography>

        <Typography
          className='BlogArticleModuleBlockQuote__author'
          variant='quote'
        >
          {PRE_AUTHOR_CONTENT} {author}
        </Typography>
      </div>
    </div>
  );
};
